export default function StepNav({ currentStep, totalSteps, stepHeaders, generalHeader }) {
  return (
    <section className="w-full select-none">
      <div className="flex justify-center mb-8">
        {stepHeaders &&
          <h2 className="text-2xl font-semibold text-portal-dark-blur text-center">
            {stepHeaders[currentStep-1] ?? ''}
          </h2>
        }
        {generalHeader && !stepHeaders && (
          <h2 className="text-2xl font-semibold text-portal-dark-blur text-center">
            {generalHeader ?? ''}
          </h2>
        )}
      </div>
      
      <div className="flex items-center justify-center space-x-4">
        {Array.from({length: totalSteps}, (_, step) => (
          <div key={step} className={`w-10 h-10 flex items-center justify-center rounded-full border-2 
            ${currentStep === step+1 ? 'border-hub-primary text-hub-primary opacity-100' : 'border-gray-300 bg-gray-100 text-gray-500 opacity-50'}`}
          >
            {step+1}
          </div>
        ))}
      </div>
    </section>
  );
};